import { modalRenderer } from '~/modal/modalRendererRegistry';
import { UndoSelectorContainer } from './undoSelector.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    Undo: undefined;
  }
}

modalRenderer.register('Undo', UndoSelectorContainer);
